import $ from 'jquery';

const editForm = '#deal-form.deal-edit-design, form.purchase-edit-panel.deal-edit-design';
let nextErrorId = 0;

function clearError(input) {
  const field = $(input);
  const errorId = field.data('edit-error-id');
  if (errorId) {
    $('#' + errorId).remove();
    const descriptions = (field.attr('aria-describedby') || '').split(/\s+/).filter(id => id && id !== errorId);
    if (descriptions.length) field.attr('aria-describedby', descriptions.join(' '));
    else field.removeAttr('aria-describedby');
    field.removeData('edit-error-id');
  }
  field.closest('.input-group').removeClass('edit-control-invalid');
  field.removeClass('edit-field-invalid').removeAttr('aria-invalid').css('border', '');
}

function activeView() {
  return window.matchMedia('(max-width: 991.98px)').matches ? '.responsive-mobile' : '.responsive-desktop';
}

function activeFields(form, itemsOnly = false) {
  const section = activeView();
  return $(form).find('input, select, textarea').filter(function() {
    if (itemsOnly && !this.classList.contains('req-fields')) return false;
    if (this.disabled || /^(hidden|file|radio|checkbox|button|submit|reset)$/.test(this.type)) return false;
    const layout = $(this).closest('.responsive-mobile, .responsive-desktop');
    if (layout.length && !layout.is(section)) return false;
    const option = $(this).closest('.meeting_section, .sending_section');
    if (option.length) {
      const delivery = $(form).find(section + ' .delivery_option:checked').val();
      if (option.hasClass('meeting_section') && delivery === 'sending_to') return false;
      if (option.hasClass('sending_section') && delivery !== 'sending_to') return false;
    }
    return true;
  });
}

function syncReceiverRequirements(form) {
  const section = activeView();
  const delivery = $(form).find(section + ' .delivery_option:checked').val();
  const notify = $(form).find(section + ' .receiver-notification-checkbox').is(':checked');
  $(form).find(section + ' [name="deal[receiver_first_name]"], ' + section + ' [name="deal[receiver_last_name]"]').prop('required', true);
  $(form).find(section + ' [name="deal[receiver_email]"]').prop('required', delivery === 'sending_to' || notify);
  $(form).find(section + ' [name="deal[receiver_address_line]"]').prop('required', delivery === 'sending_to');
  $(form).find(section + ' [name="deal[meeting_location]"]').prop('required', false);
}

function validateFields(fields) {
  let valid = true;
  $(fields).each(function() {
    clearError(this);
    if (!this.willValidate || this.validity.valid) return;
    valid = false;
    const field = $(this);
    const errorId = 'deal-edit-error-' + (++nextErrorId);
    const message = this.validity.valueMissing ? 'This field is required.' : this.validationMessage;
    field.addClass('edit-field-invalid').attr('aria-invalid', 'true')
      .attr('aria-describedby', [field.attr('aria-describedby'), errorId].filter(Boolean).join(' '))
      .data('edit-error-id', errorId);
    const group = field.is('.weight-field, .product_quantity') ? field.closest('.input-group') : $();
    if (group.length) group.addClass('edit-control-invalid');
    const frame = field.closest('.compact-field-frame, .field_with_errors');
    const anchor = group.length ? group : (frame.length ? frame : field);
    $('<small>', { id: errorId, class: 'edit-field-error', text: message }).insertAfter(anchor);
  });
  if (!valid) {
    const first = $(fields).filter('.edit-field-invalid').first();
    const collapse = first.closest('.collapse');
    if (collapse.length && !collapse.hasClass('show') && $.fn.collapse) collapse.collapse('show');
    first.trigger('focus');
  }
  return valid;
}

window.validateDealEditFields = function(fields) {
  const selected = $(fields);
  selected.filter('.req-fields').prop('required', true);
  return validateFields(selected);
};

$(document).on('input change', function(event) {
  const input = event.target;
  if (!input.matches('input, select, textarea') || !input.closest(editForm)) return;
  clearError(input);
  const wrapper = $(input).closest('.field_with_errors');
  if (wrapper.length) wrapper.replaceWith(wrapper.contents());
});

// Capture before the edit page's AJAX click handlers construct FormData.
document.addEventListener('click', function(event) {
  const button = event.target.closest('#save-btn, #save-btn1, #save-btn-shipper, #save-btn-forwarder');
  if (!button) return;
  const form = button.closest(editForm);
  if (!form) return;
  const fields = activeFields(form, true).filter('.req-fields');
  fields.prop('required', true);
  if (!validateFields(fields)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

document.addEventListener('submit', function(event) {
  const form = event.target;
  if (!form.matches(editForm)) return;
  if (form.id === 'deal-form') syncReceiverRequirements(form);
  const fields = activeFields(form);
  fields.filter('.req-fields').prop('required', true);
  if (!validateFields(fields)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);
